import { Link as ChakraLink, ListItem, OrderedList } from '@chakra-ui/react';
import { Collapse } from '@time-line/components/common';
import { useTheme } from '@time-line/components/theme';
import {
  RichTextResolver,
  SmallTextContainer,
} from 'components/common/RichTextResolver';
import type { Footnotes } from 'types/cms/Footnotes';

interface FootnotesListProps {
  footnotes: Footnotes[];
}

export function FootnotesList({ footnotes }: FootnotesListProps) {
  const theme = useTheme();

  return (
    <Collapse>
      <OrderedList spacing="2xs" pl="sm" ml={0}>
        {footnotes.map((item, i) => (
          <ListItem
            key={i}
            scrollMarginTop="3xs"
            id={`footnote-${i + 1}`}
            pl="2xs"
            pos="relative"
            sx={{
              '&::marker': {
                ...theme.components.Text.sizes.detail,
              },
              '> div > p:first-of-type': {
                textIndent: theme.space['2xs'],
              },
            }}
          >
            <ChakraLink
              href={`#citation-${i + 1}`}
              pos="absolute"
              variant="unstyled"
              textDecoration="underline"
              top={0}
              left="2xs"
              fontSize="2xs"
            >
              &#8593;
            </ChakraLink>
            {item.content && (
              <RichTextResolver
                blocks={item.content}
                container={SmallTextContainer}
              />
            )}
          </ListItem>
        ))}
      </OrderedList>
    </Collapse>
  );
}
